import { useReduxState } from 'hooks';
import { getEventLogTypes } from 'lib/events';
import { DropdownSelectable } from 'components/common/dropdown';

import type { EventLogTypeGroup } from 'shared-types';
import type { UpdateEvents } from './EventLog';

interface Props {
  onlyEventsOfType: EventLogTypeGroup;
  updateEvents: UpdateEvents;
}

const EventLogTypesFilter = ({ onlyEventsOfType, updateEvents }: Props) => {
  const { messages, serverConfig } = useReduxState();

  const handleTypeChange = async (type) => {
    await updateEvents({ type, page: 1 });
  };

  const types = getEventLogTypes({ messages, onlyEventsOfType, serverConfig });
  const keys = Object.keys(types);
  const sortedKeys = [
    keys[0],
    ...keys
      .slice(1)
      .sort((a, b) => (types[a] < types[b] ? -1 : types[a] > types[b] ? 1 : 0))
  ];

  return (
    <DropdownSelectable
      category="lighter"
      defaultValue="all"
      dropdownWhiteSpace="nowrap"
      label={messages.commonFilterByType}
      onChange={handleTypeChange}
      options={sortedKeys.map((key) => ({
        text: types[key],
        value: key
      }))}
      showSelectedText={true}
    />
  );
};

export default EventLogTypesFilter;
